import React from "react";
import PropTypes from "prop-types";
import { Chip, Typography } from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Button from "../../waybee-ui/Button";
import { OCCURRENCE_ATTACHMENT_ACCEPT } from "../../utils/occurrenceAttachmentRules";

const AttachmentText = styled(Typography)`
  margin-top: 20px;
`;

const AttachmentButton = styled(Button)`
  ${props => (props.$spaced ? "margin-top: 16px;" : "")}
`;

const AttachmentLabel = styled.label`
  display: inline-flex;
  vertical-align: top;
`;

export default function OccurrenceAttachmentFields({
  files,
  onSelect,
  onDelete,
  onOpen,
  canAdd,
  inputId,
  spacedButton
}) {
  const { t } = useTranslation();
  return (
    <>
      {canAdd && (
        <AttachmentLabel htmlFor={inputId}>
          <AttachmentButton
            variant="contained"
            color="primary"
            component="span"
            startIcon={<AttachFileIcon />}
            fullwidth
            $spaced={spacedButton}
          >
            {t("occurrences.addAttachment")}
          </AttachmentButton>
          <input
            accept={OCCURRENCE_ATTACHMENT_ACCEPT}
            id={inputId}
            name={inputId}
            multiple
            type="file"
            style={{ display: "none" }}
            onChange={event => {
              const input = event.target;
              onSelect(event);
              if (input) {
                input.value = "";
              }
            }}
          />
        </AttachmentLabel>
      )}
      {files.length !== 0 && (
        <>
          <AttachmentText variant="body1" color="textSecondary">
            {t("occurrences.attachments")}
          </AttachmentText>
          {files.map(attachment => (
            <Chip
              onDelete={onDelete ? () => onDelete(attachment) : undefined}
              onClick={onOpen ? () => onOpen(attachment) : undefined}
              key={attachment.attachmentContent || attachment.attachmentName}
              icon={<AttachFileIcon />}
              label={attachment.attachmentName}
            />
          ))}
        </>
      )}
    </>
  );
}

OccurrenceAttachmentFields.propTypes = {
  files: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func,
  onDelete: PropTypes.func,
  onOpen: PropTypes.func,
  canAdd: PropTypes.bool,
  inputId: PropTypes.string,
  spacedButton: PropTypes.bool
};

OccurrenceAttachmentFields.defaultProps = {
  files: [],
  onSelect: undefined,
  onDelete: undefined,
  onOpen: undefined,
  canAdd: false,
  inputId: "files-container",
  spacedButton: false
};
